import React from 'react';
import withIcon from '../utilities/withIcon';

const IconX = () => {
  return (
    <g>
      <path d="M12.802 2.147a.75.75 0 0 1 1.05 1.05l-.072.084L9.06 7.999l4.719 4.72a.75.75 0 0 1-.978 1.133l-.084-.072L8 9.06 3.281 13.78l-.085.072a.75.75 0 0 1-1.05-1.05l.073-.084L6.938 8 2.219 3.281a.75.75 0 0 1 .977-1.134l.085.072 4.718 4.719 4.72-4.719.083-.072z" />
    </g>
  );
};

export default withIcon(IconX);
